import { render, staticRenderFns } from "./ManageCompetitions.vue?vue&type=template&id=0f120a2e"
import script from "./ManageCompetitions.vue?vue&type=script&lang=js"
export * from "./ManageCompetitions.vue?vue&type=script&lang=js"
import style0 from "./ManageCompetitions.vue?vue&type=style&index=0&id=0f120a2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports